import Equipment from './Equipment';
import Shipment from './Shipment';

export class Tabs {
  static Shipment = Shipment;

  static Equipment = Equipment;
}
